import { render } from "./DowloadApp.vue?vue&type=template&id=7e578a0e&ts=true"
import script from "./DowloadApp.vue?vue&type=script&lang=ts"
export * from "./DowloadApp.vue?vue&type=script&lang=ts"

import "./DowloadApp.vue?vue&type=style&index=0&id=7e578a0e&lang=css"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__